interface JWTPayload {
  exp?: number;
  iat?: number;
  sub?: string;
  [key: string]: unknown;
}

export function parseJWTPayload(token: string): JWTPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const decoded = atob(padded);

    return JSON.parse(decoded);
  } catch (error) {
    console.error("Failed to parse JWT token:", error);
    return null;
  }
}

export function isTokenExpired(token: string): boolean | null {
  const payload = parseJWTPayload(token);
  if (!payload?.exp) {
    return null;
  }

  return Date.now() > payload.exp * 1000;
}
